<template>
    <div class="leasing p-6 shadow-lg rounded-lg relative">
        <div
            class="absolute top-0 right-0 bg-red text-white font-bold px-4 py-1 rounded-tr-lg z-10"
        >
            🔥 Unique en Belgique
        </div>

        <p class="text-center text-lg font-medium">
            Vous êtes un particulier et souhaitez souscrire à un forfait tout
            compris ?<br />
            Nous proposons une formule unique en Belgique :
            <strong>Le financement à 0% via Cofidis !</strong>
        </p>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full mt-4">
            <div>
                <strong>Paramètres du financement</strong>

                <div
                    class="text-left sm:text-center lg:text-left sm:grid sm:grid-cols-2 lg:grid-cols-1 sm:bg-grey lg:bg-transparent"
                >
                    <div class="mt-4">
                        <label for="maintenance_budget" class="block">
                            Budget entretien par année
                        </label>
                        <div
                            class="flex sm:items-center sm:justify-center lg:items-start lg:justify-start"
                        >
                            <input
                                type="number"
                                id="maintenance_budget"
                                min="100"
                                max="1000"
                                v-model="inputLeasingPrice.maintenanceBudget"
                                @change="updateLeasingPrice"
                                class="text-black mr-2 w-24"
                            />
                            <span>€/an</span>
                        </div>
                    </div>
                    <div>
                        <label for="contract_duration">
                            Durée du contrat
                        </label>
                        <select
                            v-model="inputLeasingPrice.contractDuration"
                            class="text-black w-24"
                            id="contract_duration"
                            @change="updateLeasingPrice"
                        >
                            <option value="24">24 mois</option>
                            <option value="36">36 mois</option>
                        </select>
                    </div>
                    <div
                        v-if="contract_type == 'leasing_b2b'"
                        class="flex sm:items-center sm:justify-center lg:items-start lg:justify-start"
                    >
                        <div class="h-4 w-4 mr-4">
                            <input
                                v-model="inputLeasingPrice.rcInsurance"
                                type="checkbox"
                                id="rc_insurance"
                                class="h-4"
                                @change="updateLeasingPrice"
                            />
                        </div>
                        <label for="rc_insurance"> Assurance RC incluse </label>
                    </div>
                    <div>
                        <label for="accompte" class="block">
                            Montant accompte
                        </label>
                        <div
                            class="flex sm:items-center sm:justify-center lg:items-start lg:justify-start"
                        >
                            <input
                                type="number"
                                id="accompte"
                                min="0"
                                :max="bike?.price_tvac"
                                v-model="inputLeasingPrice.accompte"
                                @change="updateLeasingPrice"
                                class="text-black mr-2 w-24"
                            />
                            <span>€</span>
                        </div>
                    </div>
                    <div>
                        <label for="monthly_rate" class="block">
                            Taux de financement
                        </label>
                        <div
                            class="flex sm:items-center sm:justify-center lg:items-start lg:justify-start"
                        >
                            <img
                                src="/storage/assets/images/cofidis.png"
                                alt="Cofidis"
                                class="w-24 remove_bg_color"
                            />
                            <span class="text-2xl text-red font-bold mt-3 ml-2">
                                0%
                            </span>
                        </div>
                        <primary-button
                            @click="legalInformation = true"
                            color="red items-center mt-3 ml-2 p-0 text-sm"
                        >
                            Informations légales
                        </primary-button>

                        <p class="text-xs">
                            Sous réserve d'acceptation par cofidis.<br />
                            Dossier de financement uniquement possible en
                            magasin.
                        </p>
                    </div>
                </div>
            </div>
            <!-- Left Block: Text Content -->
            <DoughnutLeasing
                :leasing_price="leasing_price"
                v-if="leasing_price"
            />
        </div>

        <div class="w-full text-center">
            <primary-button
                @click="openLeasingModal = true"
                class="mt-4 font-bold text-white"
                color="red"
                >Faire une demande en ligne</primary-button
            >
        </div>
    </div>
    <modal :open="openLeasingModal" @close="openLeasingModal = false">
        <template #title> Formulaire de demande de leasing </template>
        <template #content>
            <LeasingRequestForm />
        </template>
    </modal>
    <modal :open="legalInformation" @close="legalInformation = false">
        <template #title> Informations légales </template>

        <template #content>
            <LegalInformationCofidis />
        </template>
    </modal>
</template>
<!-- Attention-Grabbing Pin -->

<script setup>
// Chart options
import { useApiStore } from '@/js/stores/apiStore';
import DoughnutLeasing from '@/js/views/public/shop/bikes/catalog/partials/DoughnutLeasing.vue';
import { round } from 'lodash';
import { defineProps, ref } from 'vue';

import LeasingRequestForm from '@/js/views/public/shop/bikes/catalog/partials/LeasingRequestForm.vue';
import LegalInformationCofidis from '@/js/views/public/shop/bikes/catalog/partials/LegalInformationCofidis.vue';

const apiStore = useApiStore();
const openLeasingModal = ref(false);
const inputLeasingPrice = ref({
    maintenanceBudget: 100,
    contractDuration: 36,
    rcInsurance: false,
    accompte: 0,
});

const legalInformation = ref(false);

const props = defineProps({
    leasing_price: Object,
    bike: Object,
    contract_type: String,
});

const bike = ref(props.bike);

const updateLeasingPrice = () => {
    apiStore
        .apiGet('/api/leasing-price/calculate', {
            contract_type: 'leasing_b2c',
            price_htva:
                round(bike.value.price_htva * (100 - bike.value.promotion)) /
                100,
            maintenanceBudget: inputLeasingPrice.value.maintenanceBudget,
            contract_duration: inputLeasingPrice.value.contractDuration,
            rcInsurance: inputLeasingPrice.value.rcInsurance,
            accompte: inputLeasingPrice.value.accompte,
        })
        .then(response => {
            bike.value.leasing_price.tvac = response.leasing_price.tvac;
        });
};
</script>
